import { render, staticRenderFns } from "./SelectedRecipesNotification.vue?vue&type=template&id=bd40f0a2"
import script from "./SelectedRecipesNotification.vue?vue&type=script&lang=js"
export * from "./SelectedRecipesNotification.vue?vue&type=script&lang=js"
import style0 from "./SelectedRecipesNotification.vue?vue&type=style&index=0&id=bd40f0a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports